"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SUBLY_ARTWORKS = exports.ARTWORK_6 = exports.ARTWORK_5 = exports.ARTWORK_4 = exports.ARTWORK_3 = exports.ARTWORK_2 = exports.ARTWORK_1 = void 0;
exports.ARTWORK_1 = {
    id: "subly-artwork-1",
    url: "artworks/artwork-1.jpg",
    dimensions: {
        width: 1920,
        height: 1080
    },
    sublyArtwork: true
};
exports.ARTWORK_2 = {
    id: "subly-artwork-2",
    url: "artworks/artwork-2.jpg",
    dimensions: {
        width: 1920,
        height: 1080
    },
    sublyArtwork: true
};
exports.ARTWORK_3 = {
    id: "subly-artwork-3",
    url: "artworks/artwork-3.jpg",
    dimensions: {
        width: 1920,
        height: 1080
    },
    sublyArtwork: true
};
exports.ARTWORK_4 = {
    id: "subly-artwork-4",
    url: "artworks/artwork-4.jpg",
    dimensions: {
        width: 1920,
        height: 1080
    },
    sublyArtwork: true
};
exports.ARTWORK_5 = {
    id: "subly-artwork-5",
    url: "artworks/artwork-5.jpg",
    dimensions: {
        width: 1920,
        height: 1080
    },
    sublyArtwork: true
};
exports.ARTWORK_6 = {
    id: "subly-artwork-6",
    url: "artworks/artwork-6.jpg",
    dimensions: {
        width: 1920,
        height: 1080
    },
    sublyArtwork: true
};
exports.SUBLY_ARTWORKS = [
    exports.ARTWORK_1,
    exports.ARTWORK_2,
    exports.ARTWORK_3,
    exports.ARTWORK_4,
    exports.ARTWORK_5,
    exports.ARTWORK_6
];
//# sourceMappingURL=index.js.map